import { styled } from '@/UI/theme.exports';
import { Card } from '@/UI/Card/Card';

export const DashboardCard = styled(Card)({
  maxWidth: 345,
  background: 'none',
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
});
